(function ($) {

    $(document).ready(function () {
        if ($('.col-two-grid').length > 1) {
            $('.col-two-grid').each(function () {
                if ($(this).find('.two-col').length > 2) {
                    $('.col-two-grid .column-wrapper').slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true,
                        infinite: false,
                        cssEase: 'linear',
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });
                }
            });
        }
        else {
            if ($('.col-two-grid').length > 0) {
                if ($('.col-two-grid .column-wrapper .two-col').length > 2) {
                    $('.col-two-grid .column-wrapper').slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true,
                        infinite: false,
                        cssEase: 'linear',
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });
                }
            }
        }

        var item_lenght = $('#student .column-wrapper .two-col').length;
        if (item_lenght = 1) {
            $('#student .column-wrapper').slick('unslick');
             $('#student .column-wrapper').addClass('unslick');
        };    
    }); 
})(jQuery);